import React from 'react'

class Banner extends React.Component {
        render() {
          return (
          	<section className="team">
			  <div className="teaminner2">
			    <div className="teaminner">
			      <div className="teaminnermain">
			        <div className="container">
			          <div className="row">
			            <div className="col-md-5 breeserif titletext">
			              <h1 className="breeserif">Go the Distance<br />&nbsp;</h1>
			            </div>
			            <div className="col-md-push-2 col-md-5 visible-lg"><img src="images/MVP-Hero-Circle-2.png" alt="" className="img-responsive center-block" /></div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</section>
          );
        }
}

class MainContent extends React.Component {
		componentDidMount() {
		}
        render() {
          return (
          <div>
          	<div className="container">
			  <div className="infobox-video">
			    <div className="row pad-top-40">
			      <div className="col-sm-12">
			        <h1><span className="video-bg">Thank you</span></h1>

			      </div>
			    </div>
			  </div>
			</div>
			
			
		</div>	
          );
        }
}


class Footer extends React.Component {
        render() {
          return (
          	<footer>
          		<div className="container">
				  <div className="infobox-video">
					<div className="row pad-top-40">
					  <div className="col-sm-12">
						<h1></h1> 
					  </div>
					</div>
				  </div>
				</div>	
			  <div className="footer">
			    <div className="container">
			      <div className="row">
			        <div className="col-sm-6">
			          <ul className="list-unstyled">
			            <li><a href="">About MVP</a></li>
			            <li><a href="">WHY MVP?</a></li>
			            <li><a href="">Services</a></li>
			            <li><a href="">LOCATIONS</a></li>
			            <li><a href="">Contact Us</a></li>
			          </ul>
			        </div>
			        <div className="col-sm-6 text-right">
			          <div className="social">
			          </div>
			          <div className="cpt">
			            <ul className="list-unstyled">
			              <li><a href="">Privacy Policy</a></li>
			              <li><a href="">  &copy; 2017 Most Valuable Personnel</a></li>
			            </ul>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</footer>
          );
        }
}



function Thank() {
  return (
  <div>
      <Banner />
      <MainContent />
      <Footer />
  </div>    
  );
}

export default Thank


// WEBPACK FOOTER //
// ./src/thankyou.js